import { render, staticRenderFns } from "./TransferItemList.vue?vue&type=template&id=caf171ae"
import script from "./TransferItemList.vue?vue&type=script&lang=ts"
export * from "./TransferItemList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports